import { AxiosClient } from "@/app/shared/services";
import settings from "@/environment";

const state = {
    auth: {
        creditionals: {
            phone: "",
            password: "",
        },
        token: localStorage.getItem("token") || "",
        refreshToken: localStorage.getItem("refreshToken") || "",
        authUser: {},
        loginIsLoading: false,
        status: "",
        isAdmin: localStorage.getItem("isAdmin") || 0,
    },
    restorePassword: {
        emailSended: false,
        codeValidated: false,
        newPasswordWasCreated: false,
        isModalOpen: false,
    },
};

const getters = {
    AUTH_CREDITIONALS: (state) => state.auth.creditionals,
    AUTH_TOKEN: (state) => state.auth.token,
    REFRESH_TOKEN: (state) => state.auth.refreshToken,
    AUTH_USER: (state) => state.auth.authUser,
    AUTH_IS_LOADING: (state) => state.auth.loginIsLoading,
    AUTH_STATUS: (state) => state.auth.status,
    IS_LOGGED_IN: (state) => !!state.auth.token,
    IS_NEW_PASSWORD_WAS_CREATED: (state) => state.restorePassword.newPasswordWasCreated,

    IS_NEW_PASSWORD_MODAL_OPEN: (state) => state.restorePassword.isModalOpen,
    SHOW_CREDIT_SCORE_MODAL: (state) => state.auth.authUser.credit_score === null,

    IS_CLIENT: (state) => !state.auth.isAdmin,
    IS_ADMIN: (state) => !!state.auth.isAdmin,
};

const mutations = {
    SET_AUTH_CREDITIONALS: (state, creditionals) => {
        state.auth.creditionals.email = creditionals.email;
        state.auth.creditionals.phone = creditionals.phone;
        state.auth.creditionals.password = creditionals.password;
    },
    AUTH_SUCCESS: (state, token, refreshToken, user) => {
        state.auth.token = token;
        state.auth.refreshToken = refreshToken;
        state.auth.authUser = user;
        state.auth.status = "success";
    },
    AUTH_FAILED: (state) => {
        state.auth.token = "";
        state.auth.authUser = {};
        state.auth.status = "failed";
    },
    SET_AUTH_IS_LOADING: (state, isLoading) => {
        state.auth.loginIsLoading = isLoading;
    },
    SET_AUTH_USER: (state, user) => {
        state.auth.authUser = user;
    },
    AUTH_LOGOUT: (state) => {
        state.auth.token = "";
        state.auth.status = "";
        state.auth.authUser = {};

        state.auth.isAdmin = false;
    },
    UPDATE_TOKEN: (state, token) => {
        state.auth.token = token;
    },
    CHANGE_EMAIL_STATE: (state, isEmailSended) => {
        state.restorePassword.emailSended = isEmailSended;
    },
    CODE_VALIDATED: (state, isCodeValidated) => {
        state.restorePassword.codeValidated = isCodeValidated;
    },
    SET_NEW_PASSWORD_WAS_CREATED: (state, wasCreated) => {
        state.restorePassword.newPasswordWasCreated = wasCreated;
    },
    SET_NEW_PASSWORD_MODAL_IS_OPEN: (state, isOpen) => {
        state.restorePassword.isModalOpen = isOpen;
    },

    SET_PROFILE_CREDIT_SCORE: (state, score) => {
        state.auth.authUser.credit_score = score;
    },

    // Admin mutations

    SET_AUTH_AS_ADMIN: (state) => {
        state.auth.isAdmin = true;
    },
};

const actions = {
    SET_AUTH_USER: (context, user) => {
        context.commit("AUTH_SUCCESS", user.token, user.refresh_token, user);
        localStorage.setItem("token", user.token);
        localStorage.setItem("refreshToken", user.refresh_token);
        AxiosClient.defaults.headers.common.Authorization = `Bearer ${user.token}`;
    },

    SET_AUTH_CREDITIONALS: (context, payload) => {
        context.commit("SET_AUTH_CREDITIONALS", payload);
    },

    AUTH_BY_TOKEN: (context, token) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.post("/profile/loginbytoken", { token })
                .then((data) => {
                    context.commit(
                        "AUTH_SUCCESS",
                        data.data.token,
                        data.data.refresh_token,
                        data.data
                    );
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("refreshToken", data.data.refresh_token);
                    localStorage.setItem("vkid", data.data.vkid);
                    localStorage.setItem("pxlid", data.data.pxlid);
                    AxiosClient.defaults.headers.common.Authorization = `Bearer ${data.data.token}`;
                    resolve(data);
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),

    AUTH_BY_API_KEY: (context, api_key) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.get(`/profile/loginbyapikey?api_key=${api_key}`)
                .then((data) => {
                    context.commit(
                        "AUTH_SUCCESS",
                        data.data.token,
                        data.data.refresh_token,
                        data.data
                    );
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("refreshToken", data.data.refresh_token);
                    localStorage.setItem("vkid", data.data.vkid);
                    localStorage.setItem("pxlid", data.data.pxlid);
                    AxiosClient.defaults.headers.common.Authorization = `Bearer ${data.data.token}`;
                    resolve(data.data);
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),

    CREDENTIALS_BY_API_KEY: (context, api_key) => {
        return new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.get(`/profile/loginbyapikey?api_key=${api_key}`)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        });
    },

    AUTH: (context) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            if (state.auth.creditionals.password === "")
            { state.auth.creditionals.password = settings.default_password; }
            AxiosClient.post("/profile/login", state.auth.creditionals)
                .then((data) => {
                    context.commit(
                        "AUTH_SUCCESS",
                        data.data.token,
                        data.data.refresh_token,
                        data.data
                    );
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("refreshToken", data.data.refresh_token);
                    localStorage.setItem("vkid", data.data.vkid);
                    localStorage.setItem("pxlid", data.data.pxlid);
                    AxiosClient.defaults.headers.common.Authorization = `Bearer ${data.data.token}`;
                    resolve(data);
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),

    SEND_UTMS: (context, params) => {
        if (params.utm_source !== "") {
            return new Promise((resolve, reject) => {
                AxiosClient.post("/profile/save_utm", params)
                    .then((data) => {
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {});
            });
        }
    },

    AUTH_SOCIAL: (context, provider) => {
        return new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            const params = { utms: context.rootGetters.GET_UTM };
            AxiosClient.post(`/oauth/login/${provider}`, params)
                .then((response) => {
                    const data = response.data;
                    if (data.hasOwnProperty("authorization_url")) {
                        window.location.href = data.authorization_url;
                        resolve(data);
                    } else {
                        reject();
                    }
                })
                .catch(() => reject())
                .finally(() => context.commit("SET_AUTH_IS_LOADING", false));
        });
    },

    ADMIN_AUTH: (context) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.post("/admin/login", state.auth.creditionals)
                .then((data) => {
                    context.commit(
                        "AUTH_SUCCESS",
                        data.data.token,
                        data.data.refresh_token,
                        data.data
                    );
                    context.commit("SET_AUTH_AS_ADMIN");
                    localStorage.setItem("isAdmin", 1);
                    localStorage.setItem("token", data.data.token);
                    localStorage.setItem("refreshToken", data.data.refresh_token);
                    AxiosClient.defaults.headers.common.Authorization = `Bearer ${data.data.token}`;
                    resolve();
                })
                .catch((error) => {
                    context.commit("AUTH_FAILED");
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),

    LOGOUT: (context) =>
        new Promise((resolve, reject) => {
            AxiosClient.post("/profile/logout")
                .then(() => resolve())
                .catch(() => reject())
                .finally(function () {
                    context.commit("AUTH_LOGOUT");
                    localStorage.removeItem("token");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("isAdmin");
                    delete AxiosClient.defaults.headers.common.Authorization;
                });
        }),

    REFRESH_TOKEN: (context) => {
        context.commit("SET_AUTH_IS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.defaults.headers.common.Authorization = `Bearer ${state.auth.refreshToken}`;
            AxiosClient.post("/profile/refresh")
                .then((data) => {
                    const token = data.data.access_token;
                    context.commit("UPDATE_TOKEN", token);
                    localStorage.setItem("token", token);
                    resolve(token);
                })
                .catch((error) => {
                    console.log("Refresh login error: ", error);
                    store.dispatch("LOGOUT");
                    router.push({ path: "/login" });
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        });
    },

    GET_AUTH_USER: (context) => {
        context.commit("SET_AUTH_IS_LOADING", true);
        return new Promise((resolve, reject) => {
            const path = context.state.auth.isAdmin ? "/admin/authuser" : "/profile/authuser";

            AxiosClient.get(path)
                .then((data) => {
                    localStorage.setItem("vkid", data.data.vkid);
                    localStorage.setItem("pxlid", data.data.pxlid);
                    context.commit("SET_AUTH_USER", data.data);
                    resolve(data.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        });
    },

    //TODO move this actions
    SEND_CODE: (context, email) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            const params = {
                email,
            };
            AxiosClient.post("/profile/send_email_with_code", params)
                .then((data) => {
                    context.commit("CHANGE_EMAIL_STATE", true);
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),
    SEND_SMS: (context, phone) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            const params = {
                phone,
            };
            AxiosClient.post("/profile/send_sms_with_code", params)
                .then((data) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),
    RECEIVE_CODE_EMAIL: (context, params) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.post("/profile/receive_code_email", params)
                .then((data) => {
                    context.commit("CODE_VALIDATED", true);
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),
    RECEIVE_CODE_SMS: (context, params) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.post("/profile/receive_code_sms", params)
                .then((data) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),
    CREATE_NEW_PASSWORD: (context, params) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.post("/profile/create_new_password", params)
                .then(() => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),
    GET_USER_EMAIL: (context, params) =>
        new Promise((resolve, reject) => {
            context.commit("SET_AUTH_IS_LOADING", true);
            AxiosClient.get("/profile/get_user_email", { params })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_AUTH_IS_LOADING", false);
                });
        }),
    CHANGE_NEW_PASSWORD_MODAL: (context, isOpen) => {
        context.commit("SET_NEW_PASSWORD_MODAL_IS_OPEN", isOpen);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
